import axios from "axios";
import { useDispatch } from "react-redux";
import { storeUser } from "../../redux/users/usersSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { toastify } from "../toast/toastify";
import { isOAuthConnectContext } from "../exchangeOAuth";

const useApi = () => {
  const config = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    // baseURL: "https://api.copyyy.it/",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("lastVisitedRoute");
    localStorage.removeItem("rememberMe");
    // localStorage.clear()
    dispatch(
      storeUser({
        user: null,
        token: null,
      })
    );

    // login community
    // dispatch(socailSignUp(null))
  };

  // Axios request interceptor
  config.interceptors.request.use(
    (request) => {
      const token = localStorage.getItem("token");
      // const communityName = user?.leaderCommunity?.name
      const allowedPaths = [
        "/member/signup",
        "/newSignup",
        "/signup",
        "/signin",
        "/login",
        "/verifymytrades",
        "/login/newVerifyEmail",
        "/login/forgotPassword",
        "/login/createPassword/:id",
        "/cmWithNoLink/login",
      ];
      const hasOAuthCode = new URLSearchParams(location.search).has("code");
      const communityPathPattern = /^\/community\//;
      const newCommunityPathPattern = /^\/new\/community\//;
      // Add regex to match '/verifymytrades/:id' where :id is a number or string
      const verifyMyTradesWithIdPattern = /^\/verifymytrades\/(\w+)$/;
      const verifiedTradesWithNamePattern = /^\/verifiedTrades\/[\w-]+$/;
      const currentPath = location.pathname;
      if (token) {
        request.headers.Authorization = token;
      } else if (
        !token &&
        (hasOAuthCode ||
          allowedPaths.includes(currentPath) ||
          communityPathPattern.test(currentPath) ||
          newCommunityPathPattern.test(currentPath) ||
          verifyMyTradesWithIdPattern.test(currentPath) ||
          verifiedTradesWithNamePattern.test(currentPath)
        )
      ) {
        request.headers.Authorization = token;
      } else {
        navigate("/login");
        logOut();
      }
      // request.headers.Authorization = token;
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const shouldPreserveSessionOnError = (url, error) => {
    if (!isOAuthConnectContext()) return false;
    if (url === "users/loginWithByBit") return true;
    const status = error.response?.status;
    return status === 400 || status === 401 || status === 404;
  };

  const makeApiCall = async (method, url, payload) => {
    if (method === "post") {
      try {
        const response = await config.post(
          url,
          {
            ...payload,
          },
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        );

        return response?.data;
      } catch (error) {
        if (shouldPreserveSessionOnError(url, error)) {
          return error?.response?.data || "Error";
        }

        if (error.response?.status === 401) {
          toastify(
            "Your session has expired. Please login again to continue trading."
          );
          localStorage.setItem("lastVisitedRoute", window.location.pathname);
          localStorage.removeItem("token");
          dispatch(
            storeUser({
              user: null,
              token: null,
            })
          );
        } else {
          return error?.response?.data || "Error";
        }
      }
    } else if (method === "get") {
      try {
        const response = await config.get(url, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        return response?.data;
      } catch (error) {
        if (shouldPreserveSessionOnError(url, error)) {
          return error?.response?.data;
        }

        if (error.response?.status === 401) {
          toastify(
            "Your session has expired. Please login again to continue trading."
          );
          localStorage.setItem("lastVisitedRoute", window.location.pathname);
          localStorage.removeItem("token");
          dispatch(
            storeUser({
              user: null,
              token: null,
            })
          );
          navigate("/login");
        } else {
          return error?.response?.data;
        }
      }
    }
  };

  return makeApiCall;
};

export default useApi;
